module.exports = __webpack_public_path__ + "img/pic_japan_03.0176d166.jpg";